export class IntegrationsModel {
	integrationId: string;
	integrationName: string;
}

export class IntegrationDefaultSettingsModel {
	integrationClientId: string;
	useParentConfig: boolean;
	defaultClassOrganizationId: string;
	defaultClassOrganizationName: string;
}

export class IntegrationSelectedMapTypeModel {
	type: string;
	values: IntegrationMappersTypeModel[];

	constructor() {
		this.type = '';
		this.values = [];
	}
}

export class IntegrationProductTypeModel {
	key: string;
	label: string;
}

export class IntegrationMappersTypeModel extends IntegrationProductTypeModel {
	mapType: string;
	trackingSystem: string;
	trackingSystemId: string;
	trackingSystemLabel: string;
}

export class IntegrationDocumentTypeModel extends IntegrationMappersTypeModel {
	direction: string;
}

export class IntegrationOrganizationsModel {
	data: IntegrationOrganizationItemModel[];
}

export class IntegrationOrganizationItemModel {
	integrationId: string;
	integrationParentId: string;
	integrationClientId: string;
	classOrganizationId: string;
	classOrganizationName: string;
}